export default __webpack_public_path__ + "static/log-axis-a355f8e2afb0bed0bb741cadc347bafe.png";